class DateHelper {
  isValidDate(t?: Date | string | null): boolean {
    if (t === undefined || t === null || t === "") {
      return false;
    }
    const date = new Date(t);
    return !Number.isNaN(date.getTime());
  }

  parseDateTimePickString(dateString: string): Date {
    return new Date(Date.parse(dateString));
  }
  isValidHour(value: string): boolean {
    const hour = parseInt(value);
    return hour >= 0 && hour < 24;
  }
  isValidMinute(value: string): boolean {
    const minute = parseInt(value);
    return minute >= 0 && minute < 60;
  }
  isValidTime(value: string): boolean {
    if (value.length === 2) {
      return this.isValidHour(value);
    } else if (value.length === 4) {
      return (
        this.isValidHour(value.substring(0, 2)) &&
        this.isValidMinute(value.substring(2))
      );
    }
    return false;
  }
  getGap(t: number, r: number): number {
    return t - r;
  }

  getGapSpanString(t: number, r: number): string {
    return this.getGap(t, r).toString();
  }

  millisToMinutesSecondsAndMilliseconds(t: number): string {
    var d = new Date(t);
    return `${d.getUTCMinutes()}:${this.normalizeNumber(
      d.getUTCSeconds(),
      2
    )}.${this.normalizeNumber(d.getUTCMilliseconds(), 3)}`;
  }

  millisToMinutesAndSeconds(t: number): string {
    var d = new Date(t);
    return `${d.getUTCMinutes()}:${this.normalizeNumber(d.getUTCSeconds(), 2)}`;
  }

  normalizeNumber(t: number, digits: number): string {
    var result = t.toString();
    for (var i = result.length; i < digits; i++) {
      result = "0" + result;
    }
    return result;
  }

  datePickString(t?: Date | string | null): string {
    if (!this.isValidDate(t)) {
      return "";
    }
    const d = new Date(t as Date | string);
    const ds = d.toISOString();
    return ds.substring(0, ds.indexOf("T"));
  }

  dateTimePickString(t?: Date | string | null): string {
    if (this.isValidDate(t)) {
      const date = new Date(t as Date | string);
      const z = date.getTimezoneOffset() * 60000;
      const localTime = new Date(date.getTime() - z);
      return localTime.toISOString().replace("Z", "");
      // const d = new Date(t);
      // const ds = d.toISOString();
      // return ds;
      // return ds.replace('Z', '');
    } else {
      return "";
    }
  }

  timePickString(t?: Date): string {
    if (t) {
      return `${t.getHours()}:${t.getMinutes()}`;
    } else {
      return "--:--";
    }
  }

  composeDateTime(date: Date, time: string): Date | undefined {
    const milis = Date.parse(`${this.datePickString(date)}T${time}`);
    if (isNaN(milis)) {
      return undefined;
    } else {
      return new Date(milis);
    }
  }

  formatDateTime(t?: Date): string {
    if (t) {
      return t.toLocaleString();
    } else {
      return "--/--/---- --:--";
    }
  }

  formatTimeOnly(t: Date): string {
    return `00:${this.normalizeNumber(
      t.getMinutes(),
      2
    )}:${this.normalizeNumber(t.getSeconds(), 2)}`;
  }

  parseTimeString(t: string): Date {
    return new Date(`1970-01-01T${t}Z`);
  }

  isInThePast(t: Date): boolean {
    if (!this.isValidDate(t)) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);    
    return t < today;
  }
}
const DateHelperInstance = new DateHelper();

export default DateHelperInstance;
